import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import english from './locales/english.json';
import portuguese from './locales/portuguese.json';
import spanish from './locales/spanish.json';
import french from './locales/french.json';
import german from './locales/german.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            english: {
                translation: english
            },
            portuguese: {
                translation: portuguese
            },
            spanish: {
                translation: spanish
            },
            french: {
                translation: french
            },
            german: {
                translation: german
            }
        },
        fallbackLng: 'english',
        interpolation: {
            escapeValue: false
        }
    })
    .then(() => {
        document.documentElement.lang = i18n.language.split('-')[0];
        return null;
    })
    .catch((err) => {
        console.error('i18n init error:', err);
    });

i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng.split('-')[0];
});

export default i18n;
